import { lazy, Suspense, type ComponentType } from "react";
import { RouteFallback } from "@/components/RouteFallback";
import { reloadOnceOnChunkError } from "@/lib/chunk-reload";

type NamedModule = Record<string, ComponentType<unknown>>;

/** Lazy-load a named export and wrap it in Suspense for route code-splitting. */
export function lazyNamed(loader: () => Promise<NamedModule>, exportName: string): ComponentType {
  const Lazy = lazy(async () => {
    try {
      const mod = await loader();
      const Component = mod[exportName];
      if (!Component) {
        throw new Error(`Export "${exportName}" not found in lazy module`);
      }
      return { default: Component };
    } catch (error) {
      reloadOnceOnChunkError(error);
      throw error;
    }
  });

  return function LazyNamedRoute() {
    return (
      <Suspense fallback={<RouteFallback />}>
        <Lazy />
      </Suspense>
    );
  };
}
